/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Heading_Drew_BugInputs */



/**
* | output |
* | --- |
* | "We drew a bug" |
*
* @param {Error_Heading_Drew_BugInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_heading_drew_bug = /** @type {((inputs?: Error_Heading_Drew_BugInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Heading_Drew_BugInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wir haben einen Bug gezogen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous avons pioché un bug")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("我们抽到了一个 bug")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("我們抽到了一隻蟲")
	if (locale === "ko") return /** @type {LocalizedString} */ ("버그를 뽑았습니다")
	return /** @type {LocalizedString} */ ("We drew a bug")
});